(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s2s-free-payment-review"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(root){
    if(root.dataset.reviewReady)return;
    root.dataset.reviewReady='true';
    const previousPageField = root.querySelector('[data-enquiry-previous-page]');
    if (previousPageField && document.referrer) {
      try {
        const previousPage = new URL(document.referrer);
        if (previousPage.origin === window.location.origin &&
            (previousPage.pathname === '/' || /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:pages|products|collections)\/[a-z0-9-]+\/?$/i.test(previousPage.pathname))) {
          previousPageField.value = previousPage.pathname.slice(0, 240);
        }
      } catch {}
    }
    var turnover=root.querySelector('[data-review-turnover]');
    var route=root.querySelector('[data-review-route]');
    var notice=root.querySelector('[data-review-bespoke]');
    if(!turnover||!route||!notice)return;
    function update(){
      var bespoke=turnover.value!==''&&Number(turnover.value)>500000;
      route.value=bespoke?'Bespoke payment review – annual card turnover over £500,000':'Standard payment review';
      notice.hidden=!bespoke;
    }
    turnover.addEventListener('input',update);
    update();
  }
  function init(){document.querySelectorAll('[data-s2s-review]').forEach(setup)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s2s-tailored-quote"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-s2s-quote]').forEach((root) => {
    const steps = Array.from(root.querySelectorAll('[data-step]'));
    const form = root.querySelector('form');
    if (!steps.length || !form) return;
    const previousPageField = root.querySelector('[data-enquiry-previous-page]');
    if (previousPageField && document.referrer) {
      try {
        const previousPage = new URL(document.referrer);
        if (previousPage.origin === window.location.origin &&
            (previousPage.pathname === '/' || /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:pages|products|collections)\/[a-z0-9-]+\/?$/i.test(previousPage.pathname))) {
          previousPageField.value = previousPage.pathname.slice(0, 240);
        }
      } catch {}
    }
    const productOfInterest = new URLSearchParams(window.location.search).get('product');
    if (productOfInterest) root.querySelector('[data-source-product]').value = productOfInterest.slice(0, 160);
    const back = root.querySelector('[data-quote-back]');
    const next = root.querySelector('[data-quote-next]');
    const submit = root.querySelector('[data-quote-submit]');
    const progress = root.querySelector('[data-quote-progress]');
    const bar = root.querySelector('[data-quote-progress-bar]');
    const turnover = root.querySelector('#s2s-quote-turnover');
    const bespoke = root.querySelector('[data-bespoke]');
    const pricingRoute = root.querySelector('[data-quote-route]');
    let current = 0;
    root.classList.add('is-enhanced');
    form.noValidate = true;
    const show = (index, focus = false) => {
      current = index;
      steps.forEach((step, position) => { step.hidden = position !== current; });
      progress.textContent = `Step ${current + 1} of ${steps.length}`;
      bar.style.width = `${((current + 1) / steps.length) * 100}%`;
      back.hidden = current === 0;
      next.hidden = current === steps.length - 1;
      submit.hidden = current !== steps.length - 1;
      submit.style.display = current === steps.length - 1 ? 'inline-flex' : 'none';
      if (focus) {
        const heading = steps[current].querySelector('legend');
        heading.setAttribute('tabindex', '-1');
        heading.focus();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    const validate = (step) => {
      const fields = step.querySelectorAll('input,select,textarea');
      for (const field of fields) {
        if (!field.checkValidity()) { field.reportValidity(); return false; }
      }
      return true;
    };
    next.addEventListener('click', () => { if (validate(steps[current])) show(current + 1, true); });
    back.addEventListener('click', () => { if (current > 0) show(current - 1, true); });
    form.addEventListener('submit', (event) => {
      for (let index = 0; index < steps.length; index += 1) {
        const invalid = Array.from(steps[index].querySelectorAll('input,select,textarea')).find((field) => !field.checkValidity());
        if (invalid) { event.preventDefault(); show(index, true); invalid.reportValidity(); return; }
      }
    });
    const updatePricingRoute = () => {
      const bespokePricing = turnover.value === 'Over £500,000';
      bespoke.hidden = !bespokePricing;
      pricingRoute.value = bespokePricing ? 'Bespoke pricing — annual turnover over £500,000' : 'Standard tailored quote';
    };
    turnover.addEventListener('change', updatePricingRoute);
    updatePricingRoute();
    show(0);
  });

  } catch(e) { console.error(e); }
})();
})();
